import { render, staticRenderFns } from "./settlements_empty.vue?vue&type=template&id=7cb2209a&scoped=true&"
import script from "./settlements_empty.vue?vue&type=script&lang=js&"
export * from "./settlements_empty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb2209a",
  null
  
)

export default component.exports